import React from "react";

const EmptyIcon = React.memo((props) =>
  (<div
    className={`siniestro-empresa-reposo ${props.full ? "active" : ""}`}
    style={{
      height: props.size,
      width: props.size,
      borderRadius: "50%",
    }}
  />));

export default EmptyIcon;
